// Static editorial content for the Afterlight one-page site.

export const NAV_LINKS = [
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "Studio", href: "#testimonials" },
  { label: "Enquire", href: "#contact" },
];

export const HERO_VIDEO = "/videos/hero.mp4";

export const HERO_POSTER =
  "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const FEATURED_FILMS = [
  {
    id: "f1",
    title: "Station Road",
    video: "/videos/station.mp4",
    poster: "/images/station_poster.jpg",
  },
  {
    id: "f2",
    title: "Meadow View",
    video: "/videos/meadow.mp4",
    poster: "/images/meadow_poster.jpg",
  },
  {
    id: "f3",
    title: "Ridgemont",
    video: "/videos/ridgemont.mp4",
    poster: "/images/ridgemont_poster.jpg",
  },
];

export const PORTFOLIO = [
  {
    id: "p1",
    title: "Juniper House",
    location: "Ojai, California",
    type: "Private Residence",
    video:
      "https://customer-assets.emergentagent.com/job_cinematic-listings-3/artifacts/6zwxxz8j_LA%20clip_1_tvai.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_cinematic-listings-3/artifacts/y093n1jg_LA%20still-topaz-sharpen-denoise.jpeg",
    span: "lg:col-span-8",
  },
  {
    id: "p2",
    title: "Ashcombe House",
    location: "Surrey, United Kingdom",
    type: "Luxury Renovation",
    video: "/videos/ashcombe.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_cinematic-listings-3/artifacts/9c2qyvmx_Drone%20pic-topaz-denoise-sharpen.jpeg",
    span: "lg:col-span-4",
  },
  {
    id: "p3",
    title: "45 Eaton Square",
    location: "Belgravia, London",
    type: "Interior Design",
    video: "/videos/eaton.mp4",
    poster: "/images/eaton_poster.jpg",
    span: "lg:col-span-4",
  },
  {
    id: "p4",
    title: "Atelier No. 9",
    location: "Naples, Italy",
    type: "Architectural Showcase",
    video: "/videos/atelier.mp4",
    poster:
      "https://customer-assets.emergentagent.com/job_cinematic-listings-3/artifacts/iprcja9x_Pool%20frame%20still.jpg",
    span: "lg:col-span-8",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "You Send the Photography",
    body: "Share the professional stills you already commissioned. No new shoot, no drone crew, no scheduling. We begin with the assets in your hands today.",
  },
  {
    num: "02",
    title: "We Direct the Film",
    body: "Our editors pair advanced generative motion with a human eye for pacing, light and rhythm - composing each frame the way a cinematographer would.",
  },
  {
    num: "03",
    title: "You Receive a Listing Film",
    body: "A finished, broadcast-grade video delivered in days. Formatted for portals, social and private client presentations alike.",
  },
];

export const PACKAGES = [
  {
    name: "Essential Highlights",
    price: "£80",
    unit: "per property",
    summary: "A refined single film for the discerning listing.",
    features: [
      "One cinematic reel, up to 60 seconds",
      "Up to 20 source photographs",
      "Trending or tailored soundtrack",
      "Vertical or landscape",
    ],
    featured: false,
  },
  {
    name: "Cinematic Standard",
    price: "£120",
    unit: "per property",
    summary: "Our signature treatment for premium estates.",
    features: [
      "Hero film up to 90 seconds",
      "Up to 30 source photographs",
      "Bespoke score selection",
      "Vertical or landscape",
      "Priority delivery",
      "Your logo & contact details included",
    ],
    featured: true,
  },
  {
    name: "The Auteur Suite",
    price: "Bespoke",
    unit: "by commission",
    summary: "A directed series for landmark developments.",
    features: [
      "Multi-film campaign & teaser cuts",
      "Unlimited source photography",
      "Original sound design",
      "Dedicated creative director",
      "Brand-matched typography & titling",
      "White-glove delivery",
    ],
    featured: false,
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Form Pathway turned a folder of stills into a film that felt like it cost ten times the price. Three viewings booked the day it went live.",
    name: "Eleanor Voss",
    role: "Director, Voss Prime Residential",
  },
  {
    quote:
      "We brief them once and the result is always editorial, never gimmicky. It has quietly become our standard for every super-prime instruction.",
    name: "Marcus Lindqvist",
    role: "Head of Sales, Northbank Developments",
  },
  {
    quote:
      "The restraint is what sells it. No flashy effects - just light, pace and architecture. Precisely how our practice wants to be seen.",
    name: "Aria Nakamura",
    role: "Principal Architect, Studio AN",
  },
];

export const MARQUEE = [
  "Estate Agents",
  "Developers",
  "Architects",
  "Interior Designers",
  "Private Offices",
  "Property Funds",
];
